import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { GTMServiceFactory } from '..';

export const gtmTrackingGuard: CanActivateFn = route => {
  const gtmService = inject(GTMServiceFactory);

  const gtmEvent = route.data?.['gtmEvent'] as string | undefined;
  const gtmPageName = route.data?.['gtmPageName'] as string | undefined;
  const gtmAdditionalData = route.data?.['gtmAdditionalData'] as Record<string, any> | undefined;

  if (gtmEvent && gtmPageName) {
    gtmService.trackPageViewed(gtmEvent, gtmPageName, gtmAdditionalData);
  }

  return true;
};
